export const transformQuizardWinnerLeaderboardData = (data) => {
    return {
      global_rank:data.global_rank,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformQuizardWinnerLeaderboardDataArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray = dataArray.slice().sort((a, b) => {
        const rankA = a.global_rank !== undefined ? a.global_rank : Infinity;
        const rankB = b.global_rank !== undefined ? b.global_rank : Infinity;
        return rankA - rankB;
      });
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformQuizardWinnerLeaderboardData(data));
    }
    return dataArray.map(data => transformQuizardWinnerLeaderboardData(data));
  };

  export const transformWinnerlistData = (data) => {
    return {
      global_rank:data.serial_no,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformWinnerlistDataArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformWinnerlistData(data));
    }
    return dataArray.map(data => transformWinnerlistData(data));
  };